module.exports = __webpack_public_path__ + "static/mohit-10356151338bdf9e73677f75d5b4bec8.png";